var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        persistent: "",
        "max-width": _vm.maxWidth,
        "content-class": "sb-modal"
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(data) {
            return [
              !_vm.hideButton
                ? _c(
                    "span",
                    [
                      _c(
                        "v-btn",
                        {
                          class: _vm.buttonClass,
                          attrs: {
                            id: _vm.buttonId,
                            color: _vm.color,
                            small: _vm.smallButton,
                            disabled: _vm.disabled
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.openDialog($event)
                            }
                          }
                        },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attr = ref.attr
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            _vm._b(
                                              { staticClass: "mr-1" },
                                              "v-icon",
                                              attr,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(_vm.buttonIcon) +
                                                "\n            "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.buttonToolTipText))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.hideButtonText
                            ? _c("span", [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.buttonText) +
                                    "\n        "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          }
        }
      ]),
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-layout",
                { staticClass: "align-center" },
                [
                  _c("v-flex", [
                    !_vm.hideHeaderTitle
                      ? _c("h4", [_vm._v(_vm._s(_vm.headerTitle))])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  !_vm.confirmDisabled && !_vm.hideCloseIcon
                    ? _c(
                        "div",
                        {
                          staticClass: "sb-modal-close",
                          on: { click: _vm.close }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.$slots.default !== undefined
            ? _c(
                "v-card-text",
                [
                  _c(
                    "p",
                    { staticClass: "mb-0 break-word" },
                    [_vm._t("default")],
                    2
                  ),
                  _vm._v(" "),
                  _vm.typeToConfirm
                    ? _c(
                        "v-form",
                        { ref: "form" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [
                                function(v) {
                                  return (
                                    v === _vm.typeToConfirm ||
                                    "Type '" +
                                      _vm.typeToConfirm +
                                      "' to proceed"
                                  )
                                }
                              ]
                            },
                            model: {
                              value: _vm.confirmInputValue,
                              callback: function($$v) {
                                _vm.confirmInputValue = $$v
                              },
                              expression: "confirmInputValue"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.confirmWaitingToEnable
                    ? _c("p", [
                        _vm.confirmWaitingToEnable
                          ? _c("small", [
                              _vm._v(
                                "\n          Wait " +
                                  _vm._s(_vm.secondsToEnable) +
                                  " second(s) to proceed\n        "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              )
            : !_vm.noBody && !_vm.customText
            ? _c(
                "v-card-text",
                [
                  _vm._t("text-body", [
                    _c("p", [
                      _c("b", [_vm._v('"' + _vm._s(_vm.title) + '"')]),
                      _vm._v(
                        " will be " +
                          _vm._s(_vm.buttonText.toLowerCase()) +
                          "d, along\n          with all related data.\n        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._t("description")
                ],
                2
              )
            : !_vm.noBody && _vm.customText
            ? _c(
                "v-card-text",
                [
                  _vm._t("custom-text-body", [
                    _c("p", { staticClass: "mb-0 break-word" }, [
                      _vm._v(_vm._s(_vm.customText))
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._t("description")
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _vm._t("card-actions", [
                !_vm.hideCancelButton
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "sb-btn-outline-neutral",
                        attrs: { id: "CancelDelete", depressed: "" },
                        on: { click: _vm.cancel }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.cancelButtonText) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "sb-btn-primary",
                    attrs: {
                      id: "ConfirmDelete",
                      depressed: "",
                      disabled: _vm.confirmDisabled,
                      loading: _vm.confirmWaitingToEnable
                    },
                    on: { click: _vm.confirm }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.confirmButtonText) +
                        "\n        "
                    )
                  ]
                )
              ])
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }